export default "__VITE_ASSET__T0e38vJn__"